export default class NumberHelper {
  /**
   * カンマ区切りした値を返す
   *
   * @param value 対象
   * @returns カンマ区切りした値
   */
  public static convertCommaSeparated(value: string | number): string {
    if (value.toString() < '1000') {
      return value.toString();
    }
    return this.replaceCommaSeparated(value);
  }

  /**
   * @param value
   */
  public static convertIncludeTaxStyle(value: string | number): string {
    return `税込${this.convertCommaSeparated(value)}円`;
  }

  /**
   * @param value
   */
  public static convertIncludeTaxPerMonthStyle(value: string | number): string {
    return `税込${this.convertCommaSeparated(value)}円/月`;
  }

  /**
   * みんなの意見で使用する万＋カンマ区切り(9万9,999）形式にした値を返す
   *
   * @param value 対象
   * @returns 万＋カンマ区切り形式にした値
   */
  public static convertJapanUnitAndCommaSeparated(value: number): string {
    if (value < 1000) {
      return value.toString();
    }
    if (value < 10000) {
      return this.convertCommaSeparated(value);
    }

    const top = Math.floor(value / 10000);
    const bottom = Math.floor(value % 10000);

    return `${top}万${bottom > 0 ? this.replaceCommaSeparated(bottom) : ''}`;
  }
  /**
   * みんなの意見で使用する万(9万） or カンマ区切り(9,999）形式にした値を返す。小数点は四捨五入する
   *
   * @param value 対象
   * @returns 万orカンマ区切り形式にした値
   */
  public static convertJapanUnitOrCommaSeparated(value: number): string {
    if (value < 1000) {
      return value.toString();
    }
    if (value < 10000) {
      return this.convertCommaSeparated(value);
    }

    const top = Math.round(value / 10000);

    return `${top}万`;
  }

  private static replaceCommaSeparated(value: string | number): string {
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
}
